export const event_strings = {
  CHANGE_LANGUAGE: "0",
  FORM_RESET: "3",
  SHOW_MENU: "4",
  SET_BROTHER_PRINTER: "11",
  SET_BLUETOOTH_SERIAL_PRINTER: "12",

}
